import { useEffect, useRef, useState } from "react";
import { Alert, Button, Form, Input, message, Select } from "antd";
import Modal from "antd/es/modal/Modal";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";

import classes from "./TimeSlotDetailsModal.module.scss";
import {
  cellPhoneValidator,
  startPatternRule,
  validateMessages,
} from "../../utils/validation";
import { create } from "../../store/actions/booking-actions";
import timeslotsAPI from "../../API/endpoints/timeslots";

export default function TimeSlotDetailsModal({
  open,
  onClose,
  timeSlot,
  formValues,
  onBooked,
}) {
  const [secondsLeftToBook, setSecondsLeftToBook] = useState(119);
  const [isLoading, setIsLoading] = useState();

  const dispatch = useDispatch();
  const intervalRef = useRef(null);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (open) {
      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => {
          setSecondsLeftToBook((prev) => {
            if (prev > 0) {
              return prev - 1;
            } else {
              clearInterval(intervalRef.current);
              intervalRef.current = null;
              return 0;
            }
          });
        }, 1000);
      }
    } else {
      setError("");
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setSecondsLeftToBook(119);
    }
  }, [open]);

  const ReservationMessage = () => {
    return (
      <p className={classes.reservationMessage}>
        {secondsLeftToBook > 0 ? (
          <>
            RESERVED FOR:{" "}
            <span className={secondsLeftToBook > 10 ? "" : classes.danger}>
              {moment.utc(secondsLeftToBook * 1000).format("mm:ss")}
            </span>
          </>
        ) : (
          <span className={classes.warning}>RESERVATION TIME IS UP !</span>
        )}
      </p>
    );
  };

  const timeSlotTitle = `Time slot - ${moment(timeSlot?.start).format(
    "DD.MM.YYYY (HH:mm"
  )} - ${moment(timeSlot?.end).format("HH:mm")})`;

  const [error, setError] = useState("");

  const deliveryTypeOptions = useSelector(
    (state) => state.options.deliveryTypeOptions
  );

  const handleSubmit = async (values) => {
    const finalFormValues = {
      ...values,
      ...formValues,
      receiverPhone: `+${values.receiverPhone}`,
      slotTimeId: timeSlot?.id,
    };
    try {
      setIsLoading(true);
      await dispatch(create(finalFormValues));
      onBooked();
    } catch (error) {
      setError(error.response?.data?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseDetailsModal = async () => {
    if (!isLoading) {
      try {
        setIsLoading(true);
        await timeslotsAPI.releaseSlot();
      } catch (error) {
        messageApi.open({
          type: "error",
          content: "Something went wrong",
        });
      } finally {
        setIsLoading(false);
        onClose();
      }
    }
  };

  return (
    <Modal
      open={open}
      loading={isLoading}
      footer={null}
      onCancel={handleCloseDetailsModal}
      title={timeSlotTitle}
      width={"50vw"}
      className={classes.modal}
      destroyOnClose
      maskClosable={false}
    >
      {contextHolder}
      <div className={classes.container}>
        <ReservationMessage />
        {error && (
          <Alert style={{ marginTop: 0 }} message={error} type="error" />
        )}
        <Form
          onFinish={handleSubmit}
          labelCol={{ flex: "200px" }}
          labelAlign="left"
          labelWrap
          validateMessages={validateMessages}
        >
          <Form.Item
            name="deliveryType"
            label="Delivery Type"
            rules={[{ required: "true" }]}
          >
            <Select
              placeholder="Select Delivery Type"
              options={deliveryTypeOptions}
            />
          </Form.Item>

          <Form.Item
            name="companyName"
            label="Company Name"
            rules={[{ required: "true", max: 20 }, startPatternRule]}
          >
            <Input placeholder="Enter company name" />
          </Form.Item>

          <Form.Item
            name="receiverName"
            label="Receiver Name"
            rules={[{ required: "true", max: 20 }, startPatternRule]}
          >
            <Input placeholder="Enter receiver name" />
          </Form.Item>

          <Form.Item
            name="receiverPhone"
            label="Receiver Phone Number"
            rules={[
              {
                required: "true",
                validator: cellPhoneValidator("Receiver Phone Number"),
              },
            ]}
          >
            <PhoneInput
              country={"az"}
              enableSearch={true}
              placeholder="+994 (50) 000-00-00"
            />
          </Form.Item>

          <Form.Item className={classes.submitButton}>
            <Button
              disabled={!secondsLeftToBook || isLoading}
              type="primary"
              htmlType="submit"
            >
              {isLoading ? "Booking..." : "Book"}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
}
